import type { FunctionComponent } from 'react'

import { PrimaryButton, trackingService } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import type { ClientInputs } from '../../../types'

import { budgetApiClient } from '../../../api/budgetApiClient'
import { goToFlow } from '../../../store/actions/flowEntryStatemachineActions'
import { StyledRegularButtonWrapper } from '../GenericLandingPageStyledComponent'

export const CoupleSameDeviceStart: FunctionComponent<{
	clientInputs?: ClientInputs
	children?: never
}> = ({ clientInputs }) => {
	const dispatch = useDispatch()
	const { t } = useTranslation()

	return (
		<StyledRegularButtonWrapper>
			<PrimaryButton
				onClick={async () => {
					const response = await budgetApiClient.createCaseWithSubdomainInfo(
						true,
						true,
						clientInputs,
					)
					if (response?.secondaryApplicantId != null) {
						trackingService.trackEvent('Finished genericLandingPage', {
							applicantId: response.caseId,
							coApplicantId: response.secondaryApplicantId,
						})
						dispatch(goToFlow(response.secondaryApplicantId))
					}
				}}
			>
				{t('generic-landing-page-start-btn')}
			</PrimaryButton>
		</StyledRegularButtonWrapper>
	)
}
